// b99.9.82 — Elevation panel (chart + Pin "unpin" button).
// Same component used in inline and fullscreen; only the height
// changes (via prop). Mirrors the EditorPage's Pin behaviour.
// b99.9.84/.89 — Inline usa `position="bottom"` (cantos inferiores
// arredondados, encaixe limpo no card). Fullscreen usa "middle"
// (sem cantos arredondados — o painel é flat no edge do viewport).

import { Pin } from "lucide-react";
import { useTranslation } from "react-i18next";
import ElevationProfileWeb from "../ElevationProfileWeb";

export default function TripOverviewElevationPanel({
  coordinates,
  height,
  onHoverPoint,
  onClose,
  fullscreen = false,
}) {
  const { t } = useTranslation("common");
  return (
    <div className="relative flex-shrink-0" data-testid="trip-overview-elevation-panel">
      <button
        type="button"
        onClick={onClose}
        className="absolute top-2 right-2 z-10 p-1 hover:bg-orange-500/10 rounded text-orange-500"
        data-testid="trip-overview-elevation-pin"
        aria-label={t("map.controls.unpin_profile", "Desafixar perfil de altitude")}
        title={t("map.controls.unpin_profile", "Desafixar perfil de altitude")}
      >
        <Pin className="h-4 w-4" fill="currentColor" />
      </button>
      <ElevationProfileWeb
        coordinates={coordinates}
        height={height}
        onHoverPoint={onHoverPoint}
        position={fullscreen ? "middle" : "bottom"}
      />
    </div>
  );
}
